export default __webpack_public_path__ + "images/flatbutton-arrow-hover.png";